import { render } from "./MultipleChoiceToggle.vue?vue&type=template&id=713edf4d&scoped=true"
import script from "./MultipleChoiceToggle.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceToggle.vue?vue&type=script&lang=js"

import "./MultipleChoiceToggle.vue?vue&type=style&index=0&id=713edf4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713edf4d"]])

export default __exports__